import React, { useState, useEffect } from "react";
import { DataGrid, GridRowModes } from "@mui/x-data-grid";
import { collection, getDocs } from "firebase/firestore";
import { db } from "../../../config/firebase"; // Assuming you have firebase.js with your config
import Edit from "./Edit";
import { Snackbar } from "@mui/material";

function List({ refresh, onComicUpdated }) {
  const [comics, setComics] = useState([]);
  const [selectedComic, setSelectedComic] = useState(null);
  const [openEditDialog, setOpenEditDialog] = useState(false);
  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState("");

  useEffect(() => {
    const fetchComics = async () => {
      const comicsCollection = collection(db, "Comics");
      const comicsSnapshot = await getDocs(comicsCollection);
      const comicsList = comicsSnapshot.docs.map((doc) => ({
        id: doc.id,
        ...doc.data(),
      }));
      // Sort the comics list alphabetically by title (case-insensitive)
      comicsList.sort((a, b) => {
        const titleA = a.title ? a.title.toLowerCase() : ""; // Handle potential undefined titles
        const titleB = b.title ? b.title.toLowerCase() : "";
        if (titleA < titleB) {
          return -1;
        }
        if (titleA > titleB) {
          return 1;
        }
        return 0; // titles are equal
      });

      setComics(comicsList);
    };

    fetchComics();
  }, [refresh]);

  const columns = [
    { field: "title", headerName: "Title", width: 200 },
    { field: "series", headerName: "Series", width: 200 },
  ];

  const handleRowClick = (params) => {
    setSelectedComic(params.row);
    setOpenEditDialog(true);
  };

  const handleCloseEditDialog = () => {
    setOpenEditDialog(false);
    setSelectedComic(null);
  };

  const handleComicUpdated = () => {
    setSnackbarMessage("Comic updated successfully!");
    setSnackbarOpen(true);
    onComicUpdated();
  };

  const handleSnackbarClose = () => {
    setSnackbarOpen(false);
  };

  return (
    <>
      <div style={{ width: "100%" }}>
        <DataGrid
          rows={comics}
          columns={columns}
          pageSize={5}
          rowsPerPageOptions={[5, 10, 25]}
          onRowClick={handleRowClick}
        />
        {selectedComic && (
          <Edit
            open={openEditDialog}
            onClose={handleCloseEditDialog}
            comic={selectedComic}
            onComicUpdated={handleComicUpdated}
          />
        )}
      </div>
      <Snackbar
        open={snackbarOpen}
        autoHideDuration={6000}
        onClose={handleSnackbarClose}
        message={snackbarMessage}
      />
    </>
  );
}

export default List;
